import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["sectorsListState", "setSectorsListState", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box } from '@mui/material';
import { useDeviceSize } from '@hooks';
import { PriceSlider } from '@views/pages/sectors/sectors.styles';
import { jsx as _jsx } from "react/jsx-runtime";

var PriceSliderComponent = function PriceSliderComponent(_ref) {
  var _sectorsListState$fil, _sectorsListState$fil2, _sectorsListState$fil3, _sectorsListState$fil4;

  var sectorsListState = _ref.sectorsListState,
      setSectorsListState = _ref.setSectorsListState,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 240 : _ref$width,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useDeviceSize = useDeviceSize(),
      desktop = _useDeviceSize.desktop;

  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    width: width
  }, restProps), {}, {
    children: sectorsListState.filter.value && sectorsListState.filter.min !== sectorsListState.filter.max && sectorsListState.filter.min !== 1000000000 && sectorsListState.filter.max !== -1000000000 && /*#__PURE__*/_jsx(PriceSlider, {
      value: sectorsListState.filter.value,
      onChange: function onChange(event, newValue) {
        setSectorsListState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            filter: {
              value: newValue,
              min: state.filter.min,
              max: state.filter.max
            }
          });
        });
      },
      valueLabelDisplay: desktop ? 'auto' : 'on',
      valueLabelFormat: function valueLabelFormat(value) {
        return "".concat(value, " \u20BD");
      },
      defaultValue: sectorsListState.filter.value,
      min: sectorsListState.filter.min,
      max: sectorsListState.filter.max,
      marks: [{
        value: (_sectorsListState$fil = sectorsListState.filter.min) !== null && _sectorsListState$fil !== void 0 ? _sectorsListState$fil : 0,
        label: desktop ? "".concat((_sectorsListState$fil2 = sectorsListState.filter.min) !== null && _sectorsListState$fil2 !== void 0 ? _sectorsListState$fil2 : 0, " \u20BD") : ''
      }, {
        value: (_sectorsListState$fil3 = sectorsListState.filter.max) !== null && _sectorsListState$fil3 !== void 0 ? _sectorsListState$fil3 : 0,
        label: desktop ? "".concat((_sectorsListState$fil4 = sectorsListState.filter.max) !== null && _sectorsListState$fil4 !== void 0 ? _sectorsListState$fil4 : 0, " \u20BD") : ''
      }]
    })
  }));
};

export { PriceSliderComponent };